var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.msgs[_vm.forComponent]),function(message){return _c('div',{key:message.id,staticClass:"alert alert-component",class:{
			'alert-info': message.severity == 'info',
			'alert-warning': message.severity == 'warn',
			'alert-danger': message.severity == 'error'
		},attrs:{"message":message}},[_vm._v(" "+_vm._s(message.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }